/* eslint-disable arrow-body-style */
import React, { memo } from 'react';
import classNames from 'classnames';
import { User } from '@saleshandy/icons';
import { KeypadDots } from '../../../svg/keypad-dots';

interface DialerFooterProps {
  activeTab: 'keypad' | 'prospect';
  onTabChange: (tab: 'keypad' | 'prospect') => void;
}

const DialerFooter: React.FC<DialerFooterProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="dialer-footer">
      <button
        type="button"
        className={classNames('dialer-footer-tab', {
          active: activeTab === 'keypad',
        })}
        onClick={() => onTabChange('keypad')}
      >
        <KeypadDots width={16} height={16} className="dialer-footer-tab__icon" />
        <span>Keypad</span>
      </button>
      <button
        type="button"
        className={classNames('dialer-footer-tab', {
          active: activeTab === 'prospect',
        })}
        onClick={() => onTabChange('prospect')}
      >
        <User width={16} height={16} className="dialer-footer-tab__icon" />
        <span>Prospect</span>
      </button>
    </div>
  );
};

export default memo(DialerFooter);